<template>
  <div>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Plaid Categories</h3>
      </vs-row>
      <vs-row>
        <vs-col vs-lg="8" vs-sm="8" class="pr-8">
          <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
            These are Plaid Categories linked to their WalletFlo Categories
          </p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="4" class="pr-4">
          <select
            class="w-full posSelect p-3 mb-2"
            v-model="selectedSortValue"
            @change="getCategories()"
          >
            <option
              v-for="exp in sortValues"
              :key="exp.value"
              :value="exp.value"
            >
              {{ exp.text }}
            </option>
            <!-- <option selected>Default Sort: Empty First</option>
            <option>Empty Last</option>
            <option>Alphabetically</option> -->
          </select>
        </vs-col>
      </vs-row>
      <div class="w-full">
        <table class="w-full" style="border-spacing: 0px 12px;">
          <thead>
            <tr>
              <th style="padding: 0;">#</th>
              <th style="padding: 0;">Category Name</th>
              <th style="padding: 0;">Linked WalletFlo Categories</th>
              <th style="padding: 0;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(category, index) in plaid_categories">
              <tr
                v-if="category"
                :style="{
                  'background-color': index % 2 === 0 ? '#242426' : 'none'
                }"
              >
                <td style="color: gray;">{{ index + 1 }}</td>
                <td>
                  {{ category.plaidCategory && category.plaidCategory.name }}
                </td>
                <td v-if="category.categories.length > 0">
                  {{
                    category.categories
                      .map(cat => cat.name)
                      .join(", ")
                      .slice(0, 40) +
                      (category.categories.map(cat => cat.name).join(", ")
                        .length > 40
                        ? "..."
                        : "")
                  }}
                </td>
                <td v-else>
                  ------
                </td>
                <td>
                  <vs-button v-if="category._id != ''" class="mr-3" @click="toManage(category)">Manage</vs-button>
                  <vs-button
                    :disabled="category.categories.length <= 0"
                    @click="toggleExpandRow(index)"
                  >
                    {{ category.expanded ? "Close" : "View all categories" }}
                  </vs-button>
                </td>
              </tr>
              <tr
                v-if="category && category.expanded"
                :key="'expanded-' + index"
              >
                <td colspan="5" class="expanded-content">
                  <div class="w-full">
                    <transition-group type="transition" name="flip-list">
                      <vs-row
                        v-for="(cat, idx) in category.categories"
                        :key="idx"
                        class="ml-5 my-5"
                      >
                        <vs-col
                          vs-lg="6"
                          vs-sm="6"
                          class="pr-6"
                          id="inputBorder"
                        >
                          <vs-row>
                            <vs-col vs-lg="12">
                              <div class="my-2 addCardFont font-semibold">
                                WalletFlo Category #{{ idx + 1 }}
                              </div>
                              <div>{{ cat.name }}</div>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                        <vs-col
                          vs-lg="3"
                          vs-sm="3"
                          vs-type="flex"
                          vs-justify="flex-start"
                          class="flex-col"
                        >
                          <div class="my-2 addCardFont font-semibold">
                            Points
                          </div>
                          <vs-input
                            class="w-full mr-2"
                            type="number"
                            :value="cat.points || 0"
                            v-model="cat.points"
                          />
                        </vs-col>
                        <vs-col
                          vs-lg="2"
                          vs-sm="2"
                          vs-type="flex"
                          vs-justify="flex-end"
                          class="flex-col"
                        >
                          <vs-button class="ml-2" @click="handleSave(cat)">
                            Save
                          </vs-button>
                        </vs-col>
                      </vs-row>
                    </transition-group>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <vs-row v-if="errors.categories.success">
        <p class="text p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon
  },
  data() {
    return {
      plaid_categories: [],
      errors: {
        categories: {
          msg: "",
          success: false
        }
      },
      genericErrorMessage,
      toast,
      selectedSortValue: "emptyFirst",
      sortValues: [
        {
          text: "Default Sort: Empty First",
          value: "emptyFirst"
        },
        { text: "Empty Last", value: "emptyLast" },
        { text: "Alphabetically", value: "alphabetically" }
      ]
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    async toManage(inp) {
      await this.$router.push({
        path: "/credit-cards/plaid-categories/" + inp._id,
      });
    },
    async handleSave(category) {
      try {
        const data = {
          plaidCategoryIds: [
            { id: category.plaidCategoryId, points: Number(category.points) }
          ]
        };
        this.$vs.loading({ background: "rgba(1,2,3,.2)" });
        const res = await this.$axios.patch(
          `${this.$ApiKeys.BASE_URL}${this.$EndPoints.PatchPointCategory(
            category._id
          )}?type=plaid-points`,
          data
        );
        if (res.data.success) {
          this.toast("Updated Successfully!");
        } else {
          this.toast("Something went wrong!");
        }

        this.$vs.loading.close();
      } catch (error) {
        this.toast("Something went wrong!");
      }
    },
    async getCategories() {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      try {
        const res = await this.$axios.get(
          `${this.$ApiKeys.BASE_URL}${this.$EndPoints.PointCategories}?type=plaid-detailed&sort=${this.selectedSortValue}`
        );
        this.$vs.loading.close();

        if (res.data.success) {
          this.plaid_categories = res.data.data.map(category => ({
            ...category,
            expanded: false // Add expanded property to each category
          }));
          return this.plaid_categories;
        } else {
          this.toast(this.genericErrorMessage());
        }
      } catch (e) {
        if (e.response && e.response.status !== 401) {
          this.toast(this.genericErrorMessage());
        }
        this.$vs.loading.close();
      }
    },
    toggleExpandRow(index) {
      this.$set(this.plaid_categories, index, {
        ...this.plaid_categories[index],
        expanded: !this.plaid_categories[index].expanded
      });
    }
  }
};
</script>

<style>
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}

.whiteText {
  color: white !important;
}

.manageButton {
  border-radius: 10px;
  font-size: 13px;
  height: 45px;
}

.expanded-content {
  background-color: #2c2c2e;
  padding: 15px;
  border-radius: 5px;
}
.posSelect {
  background-color: #2c2c2e !important;
}
</style>
